module.exports = __webpack_public_path__ + "7cb87fa0ebdc0f23eaeac2e287be6f2b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/helm.png
// module id = 1906
// module chunks = 0